import Swiper from 'swiper/bundle';
export function initShopTheLock() {
  var swiper = new Swiper('.swiper-container-look', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 40
      }
    }
  });
  document.querySelectorAll('.product-point').forEach(function (point) {});
}